export default __webpack_public_path__ + "static/media/aqi_band_3.1f2bc907.svg";